angular.module("digitalLeasing.module").component("financialStructure", {
  templateUrl: "ng/components/digitalLeasing/financialData/financialStructure/financialStructure.view.html",
  bindings: {
    model: "=",
    onStructureChanges: "&?",
    upgradeListOfEstimates: "&",
    importOk: '&',
    importNotOk: '&',
    exportDurata: '&',
    callEconomic: '<',
    callCalcolaCanone: '&',
    callGetAssicurazioni: '&',
    snapshot: '<',
    checkEstimatesValue: '&',
    listeningForRateAndFee: '<',
    canoneTassoRunning: '<'
  },
  controllerAs: "FinancialStructureCtrl",
  controller: FinancialStructureController
});

function FinancialStructureController(
  $typeDomainService,
  $financialService,
  $filter,
  Provvigioni,
  Listino,
  $scope,
  $timeout,
  $rootScope,
  $financialApiService,
  $q,
  $configService
) {
  var self = this;
  self.$rootScope = $rootScope;

  self.$onInit = function () {
    //self.economicConditionDetail(self.model);
    self.supportModel = {
      anticipo: [],
      scadenza: [],
      periodicita: [],
      listini: self.model.leasingData.preventivo.listini || [],
      primaScadenza: {},
      importo: self.model.leasingData.preventivo.importo,
      durata: self.model.leasingData.preventivo.pianoFinanziario.durataMesi,
      listino: self.model.leasingData.preventivo.listino
    };

    var codiceProdotto = self.model.leasingData.preventivo.prodotto.id;
    if (self.snapshot && self.model.leasingData.preventivo.pianoFinanziario.primaScadenza != "" ||
      self.model.leasingData.preventivo.pianoFinanziario.primaScadenza != null) {

      if (self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == "POS") {
        self.supportModel.primaScadenza.description = 'Posticipata'

      } else if (self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == "ANT") {
        self.supportModel.primaScadenza.description = 'Anticipata'

      } else if (self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == "M07") {
        self.supportModel.primaScadenza.description = "Prima scadenza a 4 mesi"
      }
      popolateDropdown(codiceProdotto);
    } else {
      setDefaultFirstDeadline()
        .then(function (response) {
          self.model.leasingData.preventivo.pianoFinanziario.primaScadenza = response;
          popolateDropdown(codiceProdotto);
        })

    }

    if (!self.model.leasingData.preventivo.pianoFinanziario.riscatto.percentuale) {
      self.onInit = true;
      self.model.leasingData.preventivo.pianoFinanziario.riscatto.percentuale = 0;
    } else {
      self.onInit = false
    }
    if (!self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale) {
      self.onInit = true;
      self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale = 0;
    } else {
      self.onInit = false
    }

    $timeout(function () {
      /* var importo = {
        value: self.model.leasingData.preventivo.importo
      };
      self.handleFinancialStructureChange('importo', importo); */
      var durata = {
        value: self.model.leasingData.preventivo.pianoFinanziario.durataMesi
      }

      self.handleFinancialStructureChange('durata', durata);

    }, 2000);
    if (!self.model.leasingData.preventivo.pianoFinanziario.numeroRate && self.model.leasingData.preventivo.pianoFinanziario.durataMesi) {
      self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
    }

    $timeout(function () {
      $('#listino :input').prop("disabled", false);
    }, 4000)

  };

  self.$onChanges = function (changed) {
    if (changed.callEconomic && typeof changed.callEconomic.currentValue != "undefined") {
      self.economicConditionDetail(self.model);
    }

    if (changed.listeningForRateAndFee && typeof changed.listeningForRateAndFee.currentValue != "undefined") {
      checkAnticipoBeforeRestCalled();
    }

    if (changed.canoneTassoRunning && typeof changed.canoneTassoRunning.currentValue != 'undefined') {
      self.canoneTassoRunning = changed.canoneTassoRunning.currentValue
    }
  }

  self.handleFinancialStructureChange = function (property, value) {
    if (property) {
      self.model[property] = value;
    }
    switch (property) {
      case "importo":
        var controlloMinimo;
        var controlloMassimo;
        if (self.model.leasingData.preventivo.validations.importo && self.model.leasingData.preventivo.validations.importo.minimoBloccante && self.model.leasingData.preventivo.validations.importo.minimoBloccante.valore) {
          controlloMinimo = self.model.leasingData.preventivo.validations.importo.minimoBloccante.valore > self.model.leasingData.preventivo.validations.importo.minimo.valore ? self.model.leasingData.preventivo.validations.importo.minimoBloccante.valore : self.model.leasingData.preventivo.validations.importo.minimo.valore
        } else {
          controlloMinimo = self.model.leasingData.preventivo.validations.importo.minimo.valore
        }

        if (self.model.leasingData.preventivo.validations.importo && self.model.leasingData.preventivo.validations.importo.massimoBloccante && self.model.leasingData.preventivo.validations.importo.massimoBloccante.valore) {
          controlloMassimo = self.model.leasingData.preventivo.validations.importo.massimoBloccante.valore > self.model.leasingData.preventivo.validations.importo.massimo.valore ? self.model.leasingData.preventivo.validations.importo.massimoBloccante.valore : self.model.leasingData.preventivo.validations.importo.massimo.valore
        } else {
          controlloMassimo = self.model.leasingData.preventivo.validations.importo.massimo.valore
        }
        if (self.model.leasingData.preventivo.importo < controlloMinimo || self.model.leasingData.preventivo.importo > controlloMassimo) {
          self.textErroreImporto = "L'importo è fuori dal range consentito.<br/>Min: " + controlloMinimo + ";<br/>Max: " + controlloMassimo + ";"
          self.importIsValid = false;
          self.checkPage();
        } else {
          self.importIsValid = true;
          self.checkPage();
        }
        self.enableErrorImporto = !self.importIsValid;
        break;
      case "durationList":
        self.monthsOfDilations = parseInt(value.additionalProperty);
        if (value && self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == value.value) {
          return;
        }
        self.model.leasingData.preventivo.pianoFinanziario.primaScadenza = value.value;
        self.supportModel.primaScadenza = value;
        self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone durationLIst")
        self.checkPage();
        break;

      case "periodicita":
        self.model.leasingData.preventivo.pianoFinanziario.periodicita = value;
        self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone periodicità")
        self.checkPage();
        break;

      case "anticipo":
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.description = value.description;
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.id = value.value;
        if (value.description != 'MAXICANONE') {
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo = null;
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale = null;
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni = 1;
          self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        } else {
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.id = value.value
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni = null;
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo = 0;
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale = 0;
          self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        }

        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone anticipo")
        self.checkPage();
        break;

      case "riscatto":
        self.enableErrorRiscatto = false;
        self.enableErrorRiscattoLocked = false;
        if (value.currency < self.model.leasingData.preventivo.validations.riscatto.minimo.valore ||
          value.currency > self.model.leasingData.preventivo.validations.riscatto.massimo.valore) {
          self.testoRiscatto = "L'importo è fuori dal range autorizzato.<br/>Min: " + self.model.leasingData.preventivo.validations.riscatto.minimo.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.riscatto.massimo.valore + ";"
          $scope.formFinancialStructure['currency-riscatto'] && $scope.formFinancialStructure['currency-riscatto'].$setValidity('currency-riscatto', false);
          $timeout(function () {
            jQuery('#currency-riscatto').addClass('has-error');
            jQuery('#percent-riscatto').addClass('has-error');
            self.enableErrorRiscatto = true;
            self.enableErrorRiscattoLocked = false;
          }, 200)

        } else {
          $timeout(function () {
            self.enableErrorRiscatto = false;
            $scope.formFinancialStructure['currency-riscatto'] && $scope.formFinancialStructure['currency-riscatto'].$setValidity('currency-riscatto', true);
            jQuery('#currency-riscatto').removeClass('has-error');
            jQuery('#percent-riscatto').removeClass('has-error');
          }, 200)
        }

        if (value.percent < self.model.leasingData.preventivo.validations.riscattoPerc.minimoBloccante.valore ||
          value.percent > self.model.leasingData.preventivo.validations.riscattoPerc.massimoBloccante.valore) {
          self.testoRiscatto = "La percentuale è fuori dal range consentito.<br/>Min: " + self.model.leasingData.preventivo.validations.riscattoPerc.minimoBloccante.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.riscattoPerc.massimoBloccante.valore + ";"
          $scope.formFinancialStructure['currency-riscatto'] && $scope.formFinancialStructure['currency-riscatto'].$setValidity('currency-riscatto', false);
          $timeout(function () {
            jQuery('#currency-riscatto').addClass('has-error');
            jQuery('#percent-riscatto').addClass('has-error');
            self.enableErrorRiscattoLocked = true;
            self.enableErrorRiscatto = false;
          }, 200)

        } else {
          $timeout(function () {
            self.enableErrorRiscattoLocked = false;
            $scope.formFinancialStructure['currency-riscatto'] && $scope.formFinancialStructure['currency-riscatto'].$setValidity('currency-riscatto', true);
            jQuery('#currency-riscatto').removeClass('has-error');
            jQuery('#percent-riscatto').removeClass('has-error');
          }, 200)
        }

        if (value.currency == self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo &&
          value.percent == self.model.leasingData.preventivo.pianoFinanziario.riscatto.percentuale) {
          return
        }

        self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo = value.currency;
        self.model.leasingData.preventivo.pianoFinanziario.riscatto.percentuale = value.percent;
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone riscatto")
        self.checkPage();
        break;

      case "anticipoImportPerc":
        if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description != 'MAXICANONE') {
          return
        }
        if (value.currency < self.model.leasingData.preventivo.validations.anticipo.minimo.valore ||
          value.currency > self.model.leasingData.preventivo.validations.anticipo.massimo.valore) {
          self.enableErrorAnticipo = true;
          self.enableErrorAnticipoPercLock = false;
          self.testoAnticipo = "L'importo è fuori dal range autorizzato.<br/>Min: " + self.model.leasingData.preventivo.validations.anticipo.minimo.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.anticipo.massimo.valore + ";"
          $scope.formFinancialStructure['currency-anticipo'] && $scope.formFinancialStructure['currency-anticipo'].$setValidity('currency-anticipo', false);
          $timeout(function () {
            jQuery('#currency-anticipo').addClass('has-error');
            jQuery('#percent-anticipo').addClass('has-error');
          }, 200);
        } else {
          self.enableErrorAnticipo = false;
          $scope.formFinancialStructure['currency-anticipo'] && $scope.formFinancialStructure['currency-anticipo'].$setValidity('currency-anticipo', true);
          $timeout(function () {
            jQuery('#currency-anticipo').removeClass('has-error');
            jQuery('#percent-anticipo').removeClass('has-error');
          }, 200);
        }

        if (value.percent < self.model.leasingData.preventivo.validations.anticipoPerc.minimoBloccante.valore ||
          value.percent > self.model.leasingData.preventivo.validations.anticipoPerc.massimoBloccante.valore) {
          self.testoAnticipo = "La percentuale è fuori dal range consentito.<br/>Min: " + self.model.leasingData.preventivo.validations.anticipoPerc.minimoBloccante.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.anticipoPerc.massimoBloccante.valore + ";"
          self.enableErrorAnticipoPercLock = true;
          self.enableErrorAnticipo = false;
          $scope.formFinancialStructure['currency-anticipo'] && $scope.formFinancialStructure['currency-anticipo'].$setValidity('currency-anticipo', false);
          $timeout(function () {
            jQuery('#currency-anticipo').addClass('has-error');
            jQuery('#percent-anticipo').addClass('has-error');
          }, 200);
        } else {
          self.enableErrorAnticipoPercLock = false;
          $scope.formFinancialStructure['currency-anticipo'] && $scope.formFinancialStructure['currency-anticipo'].$setValidity('currency-anticipo', true);
          $timeout(function () {
            jQuery('#currency-anticipo').removeClass('has-error');
            jQuery('#percent-anticipo').removeClass('has-error');
          }, 200);
        }

        if (value.currency == self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo &&
          value.percent == self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale) {
          return
        }

        self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo = value.currency;
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale = value.percent;
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone anticipoImportPerce")
        self.checkPage();
        break;

      case "durata":
        if (value.value < self.model.leasingData.preventivo.validations.durataMesi.minimo.valore ||
          value.value > self.model.leasingData.preventivo.validations.durataMesi.massimo.valore) {
          self.enableErrorDurata = true;
          self.enableErrorDurataLocked = false;
          self.testoDurata = "L'importo è fuori dal range autorizzato.<br/>Min: " + self.model.leasingData.preventivo.validations.durataMesi.minimo.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.durataMesi.massimo.valore + ";"
          $scope.formFinancialStructure['financialStructure-durata'].$setValidity('financialStructure-durata', false);
          jQuery('#financialStructure-durata').addClass('has-error');

        } else {
          self.enableErrorDurata = false;
          $scope.formFinancialStructure['financialStructure-durata'].$setValidity('financialStructure-durata', true);
          jQuery('#financialStructure-durata').removeClass('has-error');
        }

        /* inizio parte validazione bloccante */
        if (value.value < self.model.leasingData.preventivo.validations.durataMesi.minimoBloccante.valore ||
          value.value > self.model.leasingData.preventivo.validations.durataMesi.massimoBloccante.valore) {
          self.enableErrorDurataLocked = true;
          self.enableErrorDurata = false;
          self.testoDurata = "L'importo è fuori dal range consentito.<br/>Min: " + self.model.leasingData.preventivo.validations.durataMesi.minimoBloccante.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.durataMesi.massimoBloccante.valore + ";"
          $scope.formFinancialStructure['financialStructure-durata'].$setValidity('financialStructure-durata', false);
          jQuery('#financialStructure-durata').addClass('has-error');
        } else {
          self.enableErrorDurataLocked = false;
          $scope.formFinancialStructure['financialStructure-durata'].$setValidity('financialStructure-durata', true);
          jQuery('#financialStructure-durata').removeClass('has-error');
        }
        /* fine parte validazione bloccante  */
        if (self.snapshot) {
          return;
        }
        self.supportModel.durata = value.value;
        if (self.model.leasingData.preventivo.pianoFinanziario.durataMesi == self.supportModel.durata) {
          return;
        }
        self.checkPage();
        self.model.leasingData.preventivo.pianoFinanziario.durataMesi = value.value;
        self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        self.exportDurata({
          durata: self.model.leasingData.preventivo.pianoFinanziario.durataMesi
        });
        self.callGetAssicurazioni();
        if (self.model.leasingData.preventivo.pianoFinanziario.infoTassi.tipoTasso.id != 'FIX') {
          self.economicConditionDetail(self.model);
        }

        break;


      case 'nCanoni':
        if (value < self.model.leasingData.preventivo.validations.canoniAnticipati.minimo.valore ||
          value > self.model.leasingData.preventivo.validations.canoniAnticipati.massimo.valore) {
          self.enableErrorNCanoni = true;
          self.enableErrorNCanoniLocked = false;
          self.testoNCanoni = "L'importo è fuori dal range autorizzato.<br/>Min: " + self.model.leasingData.preventivo.validations.canoniAnticipati.minimo.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.canoniAnticipati.massimo.valore + ";"
          $scope.formFinancialStructure['numeroCanoni'].$setValidity('numeroCanoni', false);
          jQuery('#numeroCanoni').addClass('has-error');
          return;
        } else {
          self.enableErrorNCanoni = false;
          $scope.formFinancialStructure['numeroCanoni'].$setValidity('numeroCanoni', true);
          jQuery('#numeroCanoni').removeClass('has-error');
        }
        if (value < self.model.leasingData.preventivo.validations.canoniAnticipati.minimoBloccante.valore ||
          value > self.model.leasingData.preventivo.validations.canoniAnticipati.massimoBloccante.valore) {
          self.enableErrorNCanoniLocked = true;
          self.enableErrorNCanoni = false;
          self.testoNCanoni = "L'importo è fuori dal range consentito.<br/>Min: " + self.model.leasingData.preventivo.validations.canoniAnticipati.minimoBloccante.valore + ";<br/>Max: " + self.model.leasingData.preventivo.validations.canoniAnticipati.massimoBloccante.valore + ";"
          $scope.formFinancialStructure['numeroCanoni'].$setValidity('numeroCanoni', false);
          jQuery('#numeroCanoni').addClass('has-error');
          return;
        } else {
          self.enableErrorNCanoniLocked = false;
          $scope.formFinancialStructure['numeroCanoni'].$setValidity('numeroCanoni', true);
          jQuery('#numeroCanoni').removeClass('has-error');
        }
        self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni = value;
        self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone Ncanoni")
        self.checkPage();
        break;

      case 'listino':
        value.ndgAggiornamento = self.model.leasingData.preventivo.listino.ndgAggiornamento;
        self.model.leasingData.preventivo.listino = Listino.build(value);
        var minValidationsDay = value && value.prodotti[0].convenzioni[0].validations.giorniDilazione.minimo.valore;
        var maxValidationsDay = value && value.prodotti[0].convenzioni[0].validations.giorniDilazione.massimo.valore;
        var validationsDayInsert = 0;
        self.model.leasingData.preventivo.fornitore.modPagamento.listaTranches
          .forEach(function (element) {
            validationsDayInsert = element.giorniDilazione
          })
        if (maxValidationsDay < validationsDayInsert ||
          minValidationsDay > validationsDayInsert) {
          jQuery('.ui-select-toggle').addClass('has-error-select');
          self.errorValidationsDays = true;
          self.checkPage();
        } else {
          self.errorValidationsDays = false;
          jQuery('.ui-select-toggle').removeClass('has-error-select');
          self.checkPage();
        }
        if (!self.model.leasingData.preventivo.pianoFinanziario.durataMesi) {
          return;
        }

        value && self.economicConditionDetail(self.model);
        break;

      case 'numeroRate':
        self.callCalcolaCanone({ value: false });
        console.log("CalcolaCanone numeroRate")
        self.checkPage();
        break;

      default:
        break;
    }
    console.log("financialStructure: ", self.model);
    self.onStructureChanges({
      financialStructure: self.model
    });
  };

  var popolateDropdown = function (codiceProdotto) {
    if (self.snapshot) {
      return
    }

    $financialApiService
      .getAdvanceType(self.model.financialVendor.riUserG.ndg)
      .then(function (response) {
        self.supportModel.anticipo = response.domainList;
        if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == "" ||
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == null) {
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.description = response.domainList[0].description;
          self.model.leasingData.preventivo.pianoFinanziario.anticipo.id = response.domainList[0].value;
        }

      });


    $financialApiService
      .getFirstDeadline(self.model.financialVendor.riUserG.ndg)
      .then(function (response) {
        self.supportModel.scadenza = response.domainList;
        if (self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == "" ||
          self.model.leasingData.preventivo.pianoFinanziario.primaScadenza == null) {
          self.supportModel.primaScadenza = response.domainList[0];
        }
        var primaScadenzaSelected = self.supportModel.scadenza.find(function (element) {
          return element.description == self.supportModel.primaScadenza.description
        })
        self.handleFinancialStructureChange("durationList", primaScadenzaSelected);
        if (!self.model.leasingData.preventivo.pianoFinanziario.numeroRate && self.model.leasingData.preventivo.pianoFinanziario.durataMesi) {
          self.model.leasingData.preventivo.pianoFinanziario.numeroRate = returnNumberOfRate();
        }
      });


    $financialService.getPeriodicita(codiceProdotto, self.model.financialVendor.riUserG.ndg)
      .then(function (response) {

        self.supportModel.periodicita = response;
        if (!self.model.leasingData.preventivo.pianoFinanziario.periodicita.id) {
          self.model.leasingData.preventivo.pianoFinanziario.periodicita = response
            .find(function (elem) {
              return elem.id == "MEN";
            });
        }
      })
      .catch(function (error) {

        console.log("error:", error);
      });

  }

  self.economicConditionDetail = function (financialModel) {
    if (self.snapshot) {
      return
    }
    self.economicIsCalled = false;
    self.model.leasingData.preventivo.assicurazioni = self.model.leasingData.preventivo.assicurazioni
      .filter(function (e) {
        return e != ""
      })
    self.economicConditionDetailIsRunning = true;
    self.checkPage();
    $financialService.economicConditionDetail(financialModel)
      .then(function (response) {
        const riferimentoCalcoloProvvigioniModel = self.model.leasingData.preventivo.pianoFinanziario.provvigioni.riferimentoCalcoloProvvigioni;
        self.model.leasingData.preventivo.validations = response.validations ? response.validations : self.model.leasingData.preventivo.validations;
        self.model.leasingData.preventivo.pianoFinanziario.provvigioni.codiceCalcoloProvvigioni = response.pianoFinanziario ? response.pianoFinanziario.provvigioni.codiceCalcoloProvvigioni : "";
        self.model.leasingData.preventivo.pianoFinanziario.provvigioni.codicePeriodLiquidProvvigioni = response.pianoFinanziario ? response.pianoFinanziario.provvigioni.codicePeriodLiquidProvvigioni : "";

        if (response.pianoFinanziario) {
          self.model.leasingData.preventivo.pianoFinanziario.provvigioni.riferimentoCalcoloProvvigioni = response.pianoFinanziario.provvigioni.riferimentoCalcoloProvvigioni
          self.upgradeListOfEstimates({
            lista: response
          });
        }
        /*         var importo = {
                  value: self.model.leasingData.preventivo.importo
                };*/
        self.handleFinancialStructureChange('importo');

        var durata = {
          value: self.model.leasingData.preventivo.pianoFinanziario.durataMesi
        };
        self.handleFinancialStructureChange('durata', durata);

        var riscatto = {
          currency: self.model.leasingData.preventivo.pianoFinanziario.riscatto.importo,
          percent: self.model.leasingData.preventivo.pianoFinanziario.riscatto.percentuale
        }
        self.handleFinancialStructureChange('riscatto', riscatto);
        var anticipo = {
          currency: self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo,
          percent: self.model.leasingData.preventivo.pianoFinanziario.anticipo.percentuale
        }
        self.handleFinancialStructureChange('anticipoImportPerc', anticipo);
        $timeout(function () {
          self.economicIsCalled = true;
          self.economicConditionDetailIsRunning = false;
          self.checkPage();
        }, 500)
        if (response.pianoFinanziario) {
          if (response.pianoFinanziario.provvigioni.riferimentoCalcoloProvvigioni == riferimentoCalcoloProvvigioniModel ||
            self.model.leasingData.preventivo.pianoFinanziario.provvigioni.importo == 0 ||
            !(self.model.leasingData.preventivo.pianoFinanziario.provvigioni.forzate ||
              self.model.leasingData.preventivo.pianoFinanziario.provvigioni.digitate)
          ) {
            self.checkEstimatesValue();
            self.callCalcolaCanone({ value: true });
          }
          console.log("CalcolaCanone fine EconomicCondition")
          $timeout(function () {
            self.checkEstimatesValue();
          }, 2650)
        }
      })
      .catch(function (error) {
        console.log(error);
        self.economicIsCalled = true;
        self.economicConditionDetailIsRunning = false;
        self.checkPage();
      })
  }

  var returnNumberOfRate = function () {

    var value = 0;
    var durataMesi = self.model.leasingData.preventivo.pianoFinanziario.durataMesi &&
      parseInt(self.model.leasingData.preventivo.pianoFinanziario.durataMesi);
    if (!self.model.leasingData.preventivo.pianoFinanziario.periodicita.description) {
      self.model.leasingData.preventivo.pianoFinanziario.periodicita.description = "mensile";
      self.model.leasingData.preventivo.pianoFinanziario.anticipo.description = "MAXICANONE"
    }
    var periodicita = $filter("returnNumberToMonth")(self.model.leasingData.preventivo.pianoFinanziario.periodicita.description) &&
      $filter("returnNumberToMonth")(self.model.leasingData.preventivo.pianoFinanziario.periodicita.description);
    var numeroCanoni = self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni &&
      parseInt(self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni);

    if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == "MAXICANONE") {
      value = Math.round((durataMesi / periodicita) - 1 - self.monthsOfDilations);
    } else {
      value = Math.round((durataMesi / periodicita) - numeroCanoni - self.monthsOfDilations);
    }

    if (value < 2) {
      value = 2;
    }
    if (!durataMesi) {
      value = null;
    }

    return value;

  }

  self.checkPage = function () {
    var test = !!!self.errorValidationsDays &&
      self.importIsValid &&
      !!self.model.leasingData.preventivo.pianoFinanziario.durataMesi &&
      !!self.model.leasingData.preventivo.pianoFinanziario.numeroRate &&
      self.economicIsCalled &&
      !self.enableErrorDurataLocked &&
      !self.enableErrorRiscattoLocked &&
      !self.loaderChangeListino &&
      !self.economicConditionDetailIsRunning &&
      !!self.model.leasingData.preventivo.pianoFinanziario.provvigioni.codiceCalcoloProvvigioni &&
      !!self.model.leasingData.preventivo.listino.ndgListino


    if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.description == "MAXICANONE") {
      test = test && typeof self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo != "undefined" &&
        !self.enableErrorAnticipoPercLock
    } else {
      test = test && typeof self.model.leasingData.preventivo.pianoFinanziario.anticipo.numeroCanoni != "undefined" &&
        !self.enableErrorNCanoniLocked
    }

    if (test) {
      self.importOk();
    } else {
      self.importNotOk();
    }
  }

  self.showHideListini = function () {
    self.model.leasingData.showAllListini = !self.model.leasingData.showAllListini;
    getListini();
  }

  var getListini = function () {
    $rootScope.$broadcast("componentLoader", { action: "OPEN" });
    self.loaderChangeListino = true;
    self.checkPage();
    $financialApiService.getListini(self.model)
      .then(function (response) {
        self.supportModel.priceList = response.listini;
        var listinoDefault = response.listini
          .find(function (element) {
            return element.defaultListino == true;
          })
        if (!listinoDefault) {
          listinoDefault = response.listini[0];
        }

        self.model.leasingData.preventivo.listino.ndgAggiornamento = $configService.getUser().ndg;
        self.handleFinancialStructureChange("listino", listinoDefault);
        self.supportModel.listini = response.listini;
        self.model.leasingData.preventivo.listini = response.listini;
        $rootScope.$broadcast("componentLoader", { action: "CLOSE" });
        self.loaderChangeListino = false;
        $('#listino :input').prop("disabled", false);
        self.checkPage();
      })
      .catch(function (error) {
        console.log(error);
        $rootScope.$broadcast("componentLoader", { action: "CLOSE" });
        self.loaderChangeListino = false;
        $('#listino :input').prop("disabled", false);
        self.checkPage();
      })
  }

  var setDefaultFirstDeadline = function () {

    return $q(function (resolve, reject) {

      if (self.model.leasingData.preventivo.convenzioni[0] && self.model.leasingData.preventivo.convenzioni[0].cdConvenzione) {

        $typeDomainService
          .getDomainSet("FIRST_PAYMENT", "DEFAULT_BY_CNV")
          .then(function (response) {
            var defaultValue = response.domainList
              .find(function (element) {
                return element.value == self.model.leasingData.preventivo.convenzioni[0].cdConvenzione;
              })
            if (defaultValue) {
              resolve(defaultValue.additionalProperty);
            } else {
              resolve(null);
            }

          })

      } else {
        resolve(null);
      }

    })

  }

  var checkAnticipoBeforeRestCalled = function () {

    if (self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo < self.model.leasingData.preventivo.validations.anticipo.minimo.valore ||
      self.model.leasingData.preventivo.pianoFinanziario.anticipo.importo > self.model.leasingData.preventivo.validations.anticipo.massimo.valore) {
      self.enableAnticipoTotale = true;
      self.mexAnticipoTotale = "L'importo di anticipo totale determinato è fuori dal range consentito.<br/>Min: " +
        self.model.leasingData.preventivo.validations.anticipo.minimo.valore + "<br/>Max: " +
        self.model.leasingData.preventivo.validations.anticipo.massimo.valore
    } else {
      self.enableAnticipoTotale = false;
    }
  }


}